<template>
  <div>
    {{value | dataListFormat}}
  </div>
</template>

<script>
import filters from "@/mixins/filters";
export default {
  name: 'crm-form-name',
  mixins: [filters],
  props: {
    scope: Object,
    value: [String, Array],
    options: Array,
    props: {
      default: () => {
        return {
          label: 'label',
          value: 'value'
        }
      }
    }

  },
  computed: {
    getName () {
      const { options, value, props } = this
      if (Array.isArray(options) && options.length > 0) {
        const { label } = options.find(item => item[props.value] === value)
        return label
      }
      return this.value
    }
  },
}
</script>

<style lang="scss" scoped>
</style>